import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { environment } from 'src/environments/environment';
import {MenuStackItem} from "@angular/cdk/menu";

@Directive({
  standalone: true,
  selector: '[menuEnabled]'
})
export class MenuEnabledDirective {
  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {}

  @Input() set menuEnabled(menuKey:string) {
    const menu = environment.menu as { [key: string]: boolean };
    const isEnabled = !!menu[menuKey];
    if (isEnabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    } else {
      this.viewContainer.clear();
    }
  }
}
